import { template as template_d188817a99874690ad837ca8b58fe99e } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { fn } from '@ember/helper';
import { not, eq } from 'ember-truth-helpers';
import SizeCard from 'eflex/components/work-instruction-editor/size-card';
import OptionsWithDefault from 'eflex/components/options-with-default';
import StandardModal from 'eflex/components/standard-modal';
import BsForm from 'eflex/components/bs-form';
import { isPresent } from '@ember/utils';
export default class WorkInstructionEditorCreateModal extends Component {
    get isCustomPreset() {
        return !this.args.selectedPreset?.ratio;
    }
    static{
        template_d188817a99874690ad837ca8b58fe99e(`
    <StandardModal
      class="jem wie-create-modal"
      @size="lg"
      @onConfirm={{@onConfirm}}
      @onCancel={{@onCancel}}
      @contentClass="h-100"
      ...attributes
    as |modal|>
      <modal.header
        @text={{t "jem.workInstructions"}}
        @subtext={{t "workInstructionEditor.create"}}
        class="bg-gray-100"
      />
      <modal.body class="d-flex position-relative p-0">
        <div class="row w-100 g-0">
          <div class="col-8 size-cards">
            <div class="p-4">
              <div class="row">
                {{#each @sizeCards as |sizeCard|}}
                  <div class="col">
                    <SizeCard
                      @sizeCard={{sizeCard}}
                      @cardClick={{@selectPreset}}
                      @isSelected={{if (eq sizeCard @selectedPreset) true}}
                    />
                  </div>
                {{/each}}
              </div>
            </div>
          </div>
          <div class="col-4 border-start border-gray-200 h-100 position-absolute top-0 end-0 eflex-scroll">
            <div class="d-flex flex-column p-4 h-100">
              {{#if @selectedPreset}}
                <BsForm @model={{@workInstruction}} as |form|>
                  <div class="row form-row gy-4">
                    <div class="col-12">
                      <form.element
                        @controlType="text"
                        class="work-instruction-author"
                        @label={{t "author"}}
                        @property="authorUsername"
                      as |el|>
                        <el.control
                          placeholder={{@workInstruction.authorUsername}}
                          readonly={{true}}
                        />
                      </form.element>
                    </div>
                    <div class="col-12">
                      <form.element
                        @controlType="text"
                        @label={{t "filename"}}
                        @property="name"
                        class="work-instruction-name"
                      as |el|>
                        <el.control placeholder={{t "workInstructions.untitled" }} />
                      </form.element>
                    </div>
                    <div class="col-6">
                      <form.element
                        @controlType="number"
                        @label={{t "imageEditor.width"}}
                        @property="width"
                        class="work-instruction-width {{if this.isCustomPreset "is-required"}}"
                      as |el|>
                        <el.control
                          placeholder={{@workInstruction.width}}
                          readonly={{isPresent @selectedPreset.ratio}}
                        />
                      </form.element>
                    </div>
                    <div class="col-6">
                      <form.element
                        @controlType="number"
                        @label={{t "imageEditor.height"}}
                        @property="height"
                        class="work-instruction-height {{if this.isCustomPreset "is-required"}}"
                      as |el|>
                        <el.control
                          placeholder={{@workInstruction.height}}
                          readonly={{not this.isCustomPreset}}
                        />
                      </form.element>
                    </div>
                    <div class="col-12">
                      <OptionsWithDefault
                        @options={{@folders}}
                        @defaultOption={{@defaultFolder}}
                        @displayedField="name"
                        @selected={{@workInstruction.folder}}
                      as |options selectedOption|>
                        <form.element
                          @controlType="power-select"
                          class="work-instruction-folder"
                          @options={{options}}
                          @optionLabelPath="name"
                          @value={{selectedOption}}
                          @label={{t "libraryFolder"}}
                          @onChange={{fn (mut @workInstruction.folder)}}
                        as |el|>
                          <el.control
                            class="standard-select"
                            @triggerClass="form-control"
                          />
                        </form.element>
                      </OptionsWithDefault>
                    </div>
                    <div class="col-12">
                      <form.element
                        class="work-instruction-version"
                        @controlType="text"
                        @label={{t "version"}}
                        @property="userVersion"
                      as |el|>
                        <el.control placeholder={{@autoVersion}} />
                      </form.element>
                    </div>
                    <div class="col-12">
                      <form.element
                        @controlType="textarea"
                        class="work-instruction-notes"
                        @label={{t "notes"}}
                        @property="notes"
                      />
                    </div>
                  </div>
                </BsForm>
              {{else}}
                <div class="h-100 d-flex align-items-center justify-content-center">
                  <h6 class="text-gray-500 fw-semibold">
                    {{t "selectAnOption"}}
                  </h6>
                </div>
              {{/if}}
            </div>
          </div>
        </div>
      </modal.body>
      <modal.footer as |footer|>
        <footer.confirm class="create-submit" @disabled={{@workInstruction.isInvalid}}>
          {{t "create"}}
        </footer.confirm>
        <footer.close />
      </modal.footer>
    </StandardModal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    ;
}
